import styled from '@emotion/styled'

const ContentFilters = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`

export default ContentFilters
